import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {MenuMode, MenuService} from '../../shared/menu.service';

@Injectable()
export class ECResolverService implements Resolve<void> {

    constructor(private readonly menuService: MenuService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
        this.menuService.enableMenu(MenuMode.ENERGY_COMMUNITY);
        this.menuService.disableTree();
    }
}
